module.exports = __webpack_public_path__ + "static/img/bg9.b6cf227b.webp";